import { useEffect, useState } from "react"
import { getRamoById, postRamo, patchRamo } from "../../services/RamosServices"
import { RamosFormContext } from "./RamosContext"
import { useNavigate, useParams } from 'react-router-dom';
//import { Color } from '../../routes/RoutesConstants'

export const RamosFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()
    const [data, setData] = useState()

    useEffect(() => {
        if (id) getRamosByIdData(id)
    }, [])

    const getRamosByIdData = async (id) => {
        let res = await  getRamoById(id)
        if (res) setReport(res)
    }

    const postRamoData = async (body) => {
        const res = await postRamo(body)
        if (res) navigate("/Ramos");
    }

    const patchRamoData = async (id, body) => {
        const res = await patchRamo(id, body)
        if (res) navigate("/Ramos");
    }


    return <RamosFormContext.Provider value={{
        report,
        postRamoData,
        patchRamoData,
        data
    }} >
        {children}
    </RamosFormContext.Provider>
}